var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { staticClass: "mb-1" },
        [
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.policies"), active: "" },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.product_rules") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/product_rules")
              },
            },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.requests") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/requests")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "cancellation_policies.create",
              expression: "'cancellation_policies.create'",
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("cancellation.new_policy"))),
          ]),
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          hide_actions: true,
          route_name: "cancellation_policies",
          order_column: "id",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.policy"))),
                ]),
                _c("vs-th", { key: "establishments" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.establishments"))),
                ]),
                _c(
                  "vs-th",
                  { key: "applies_to", attrs: { "sort-key": "applies_to" } },
                  [_vm._v(_vm._s(_vm.$t("cancellation.applied_to")))]
                ),
                _c("vs-th", { key: "version" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.version"))),
                ]),
                _c("vs-th", { key: "effective" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.effective_since"))),
                ]),
                _c("vs-th", { key: "status" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.status"))),
                ]),
                _c("vs-th", { key: "actions" }, [_vm._v("Ações")]),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.id))]),
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "18%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.name))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "establishments", attrs: { width: "16%" } },
                      [
                        _c("div", [
                          _vm._v(_vm._s(tr.establishment_names || "—")),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-td",
                      { key: "applies_to", attrs: { width: "22%" } },
                      [_c("div", [_vm._v(_vm._s(tr.applies_to))])]
                    ),
                    _c("vs-td", { key: "version", attrs: { width: "8%" } }, [
                      tr.active_version
                        ? _c("span", [
                            _vm._v("v" + _vm._s(tr.active_version.version)),
                          ])
                        : tr.draft_version
                        ? _c("span", [
                            _vm._v("v" + _vm._s(tr.draft_version.version)),
                          ])
                        : _c("span", [_vm._v("—")]),
                    ]),
                    _c("vs-td", { key: "effective", attrs: { width: "12%" } }, [
                      tr.active_version && tr.active_version.effective_from
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatDate(
                                    tr.active_version.effective_from
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [_vm._v("—")]),
                    ]),
                    _c("vs-td", { key: "status", attrs: { width: "17%" } }, [
                      _c(
                        "span",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          tr.active_version
                            ? _c(
                                "vs-chip",
                                {
                                  staticClass: "text-base",
                                  attrs: { transparent: "", color: "success" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "cancellation.version_status_.AC"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          tr.draft_version
                            ? _c(
                                "vs-chip",
                                {
                                  staticClass: "text-base",
                                  attrs: { transparent: "", color: "warning" },
                                },
                                [
                                  _vm._v(
                                    " v" +
                                      _vm._s(tr.draft_version.version) +
                                      " · " +
                                      _vm._s(
                                        _vm.$t(
                                          "cancellation.version_status_.DR"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c("vs-td", { key: "actions", attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "cancellation_policies.edit",
                                expression: "'cancellation_policies.edit'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning cursor-pointer",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(tr.id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "cancellation_policies.delete",
                                expression: "'cancellation_policies.delete'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function ($event) {
                                return _vm.confirmDestroy(tr)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }